/* @flow */
import * as React from "react";
import * as Types from "./NextGenChartTypes";
import type { IndicatorConfig } from "../../redux/reducer/settings";

const MovingAverage = React.lazy(() => import("./MovingAverage"));
const ParabolicSAR = React.lazy(() => import("./ParabolicSAR"));
const Alligator = React.lazy(() => import("./Alligator"));
const BollingerLines = React.lazy(() => import("./BollingerLines"));

type Props = {
  data: Array<Types.RenderablePoint>,
  width: number,
  height: number,
  scaleX: (date: number) => number,
  scaleY: (value: number) => number,
  config: IndicatorConfig
};

function Indicator(props: Props) {
  switch (props.config.type) {
    case "Alligator":
      // $FlowFixMe React 16 feature
      return <Alligator {...props} />;
    case "MovingAverage":
      // $FlowFixMe React 16 feature
      return <MovingAverage {...props} />;
    case "ParabolicSAR":
      // $FlowFixMe React 16 feature
      return <ParabolicSAR {...props} />;
    case "BollingerLines":
      // $FlowFixMe React 16 feature
      return <BollingerLines {...props} />;
    default:
      return null;
  }
}

export default (props) => (
  <React.Suspense fallback={null}>
    <Indicator {...props} />
  </React.Suspense>
);



// WEBPACK FOOTER //
// ./src/components/Chart/Indicator.js